import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import API_URL from "../../config/ApiUrl";

export const getCustomerAccountTypes = createAsyncThunk(
  "customerAccountType/get",
  async (payload, { rejectWithValue, dispatch }) => {
    try {
      dispatch(setActivePayload(payload));
      const filteredPayload = Object.fromEntries(
        Object.entries(payload).filter(
          ([, value]) => value !== null && value !== undefined && value !== "",
        ),
      );
      const params = new URLSearchParams();
      for (const [key, value] of Object.entries(filteredPayload)) {
        if (Array.isArray(value)) {
          value.forEach((item) => {
            params.append(key, item);
          });
        } else {
          params.append(key, value);
        }
      }
      const queryString = params.toString();
      const { data } = await axios.get(
        `${API_URL.CUSTOMER_ACCOUNT_TYPE.SLUG}?${queryString}`,
      );
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

// Lookup variant — hits the permission-free /lookup endpoint. Used by dropdowns
// on screens of other modules; the management list keeps using getCustomerAccountTypes.
export const getCustomerAccountTypesLookup = createAsyncThunk(
  "customerAccountType/getLookup",
  async (payload, { rejectWithValue }) => {
    try {
      const filteredPayload = Object.fromEntries(
        Object.entries(payload).filter(
          ([, value]) => value !== null && value !== undefined && value !== "",
        ),
      );
      const params = new URLSearchParams();
      for (const [key, value] of Object.entries(filteredPayload)) {
        if (Array.isArray(value)) {
          value.forEach((item) => {
            params.append(key, item);
          });
        } else {
          params.append(key, value);
        }
      }
      const queryString = params.toString();
      const { data } = await axios.get(
        `${API_URL.CUSTOMER_ACCOUNT_TYPE.LOOKUP}?${queryString}`,
      );
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const createCustomerAccountType = createAsyncThunk(
  "customerAccountType/create",
  async (payload, { rejectWithValue }) => {
    try {
      const { data } = await axios.post(
        `${API_URL.CUSTOMER_ACCOUNT_TYPE.SLUG}`,
        payload,
      );
      return data.data;
    } catch (error) {
      return rejectWithValue(error.data);
    }
  },
);

export const editCustomerAccountType = createAsyncThunk(
  "customerAccountType/put",
  async (payload, { rejectWithValue }) => {
    try {
      const { data } = await axios.put(
        `${API_URL.CUSTOMER_ACCOUNT_TYPE.SLUG}`,
        payload,
      );
      return data.data;
    } catch (error) {
      return rejectWithValue(error.data);
    }
  },
);

export const deleteCustomerAccountType = createAsyncThunk(
  "customerAccountType/delete",
  async (id, { rejectWithValue }) => {
    try {
      const { data } = await axios.delete(
        `${API_URL.CUSTOMER_ACCOUNT_TYPE.SLUG}/${id}`,
      );
      return data.data;
    } catch (error) {
      return rejectWithValue(error.data);
    }
  },
);

const customerAccountTypeSlice = createSlice({
  name: "customerAccountType",
  initialState: {
    customer_account_type_list: [],
    current_values: null,
    active_payload: null,
  },
  reducers: {
    setCurrentValues(state, action) {
      state.current_values = action.payload;
    },
    setActivePayload(state, action) {
      state.active_payload = action.payload;
    },
    resetCurrentValue(state) {
      state.current_values = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getCustomerAccountTypes.fulfilled, (state, action) => {
      state.customer_account_type_list = action.payload.data.list;
    });
    builder.addCase(getCustomerAccountTypesLookup.fulfilled, (state, action) => {
      state.customer_account_type_list = action.payload.data.list;
    });
  },
});

export const { setCurrentValues, setActivePayload, resetCurrentValue } =
  customerAccountTypeSlice.actions;
export default customerAccountTypeSlice.reducer;
